import { render, staticRenderFns } from "./fireFightingTraningEduPlanTab.vue?vue&type=template&id=38860ade"
import script from "./fireFightingTraningEduPlanTab.vue?vue&type=script&lang=js"
export * from "./fireFightingTraningEduPlanTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38860ade')) {
      api.createRecord('38860ade', component.options)
    } else {
      api.reload('38860ade', component.options)
    }
    module.hot.accept("./fireFightingTraningEduPlanTab.vue?vue&type=template&id=38860ade", function () {
      api.rerender('38860ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/fte/fireFightingTraningEduPlanTab.vue"
export default component.exports